import { memo } from 'react';
import classNames from 'classnames/bind';

import PlanItemMobileStyles from './planItemMobile.module.scss';
import withComponentName from '../../../decorators/withComponentName';
import usePriceCurrency from '../PriceCurrencyProvider/usePriceCurrency';

const cx = classNames.bind(PlanItemMobileStyles);

// component used for registered user to show plan card(on mobile devices)
const PlanItemMobileCard = (props) => {
  const {
    planTitleClass,
    basic,
    headTitle,
    silver,
    planImg,
    images,
    openMobilePlanCard,
    text,
    currentPlan,
    smallestPrice,
    largestPrice,
  } = props;

  const { currencySymbol, currencyShort } = usePriceCurrency();

  return (
    <div className={cx('mobile-body', 'plan-card')}>
      <div className={cx('plan-header')}>
        <h2>{headTitle}</h2>
      </div>
      <div className={planTitleClass}>
        {basic && <p>{text}</p>}
        {!basic && (
          <div className={PlanItemMobileStyles['price-start']}>
            <div className={PlanItemMobileStyles.value}>
              <span className={PlanItemMobileStyles.cost}>
                {currencySymbol}
                {`${smallestPrice}${largestPrice !== smallestPrice ? `-${largestPrice}` : ''}`}
              </span>
              &nbsp;
              {currencyShort}
              /mo
            </div>
            {silver && (
              <div className={
                cx('silver-trial-badge', 'plan-card-badge')
              }
              >
                Try 7-days FREE trial!
              </div>
            )}
          </div>
        )}
      </div>
      <div className={planImg}>
        <picture className="text-center">
          <source media="(max-width: 767px)" srcSet={images.smallImg} />
          <source media="(max-width: 1023px)" srcSet={images.mediumImg} />
          <img src={images.bigImg} alt="Blue bird" />
        </picture>
      </div>
      <div className={cx('plan-spec-btn-wrapper')}>
        <button
          type="button"
          className={PlanItemMobileStyles['plan-spec-btn']}
          onClick={() => openMobilePlanCard(true, `${currentPlan}-id`)}
        >
          See Plan
        </button>
      </div>
    </div>
  );
};

export default withComponentName(memo(PlanItemMobileCard));
